module.exports = __webpack_public_path__ + "static/media/3pic@2x.9b2bc1c3.png";